<template>
    <div class="p-8 bg-gray-200 min-h-screen">


        <div v-if="done" class="rounded-md bg-green-100 p-4 ">
            <div class="flex">
                <div class="flex-shrink-0">
                    <!-- Heroicon name: check-circle -->
                    <svg class="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                </div>
                <div class="ml-3">
                    <h3 class="text-sm font-medium text-green-800">
                        {{ _("Your address have been successfully updated. Close this screen and start using Livro App. Thanks!") }}
                    </h3>
                    <div class="mt-2 text-sm text-green-700">
                        <p>
                            {{ customer.address }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        
        <AddressChange v-else :app_locale="app_locale" v-model="customer" :standalone="true" @close="done=true"></AddressChange>
        
        
    </div>
</template>

<script>

import {lang} from "../../lang";
import AddressChange from "../../Shared/AddressChange";

export default {
  name: "ChangeAddress",
    props: ['token', 'customerprop', 'app_locale'],
    components: {
        AddressChange
      
    },
    
    computed: {
        message() {
            return this._("Your total is $%s taxes included. Your delivery address is: %s").split("%s");
        }
    },
    
    data() {
        return {
            customer: this.customerprop,
            done: false,
        }
    },
    methods: {

        _(k) {
            return lang(k, this.app_locale === 'fr_CA' ? 'fr' : 'en')
        },
    }
    
}
</script>

<style scoped>

</style>
